import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable, action } from 'mobx'
import PropTypes from 'prop-types'

import ExpertHistory from './ExpertHistory'
import Spinner from '@components/spinner'

class ExpertHistoryPage extends Component {
  static propTypes = {
    historyStore: PropTypes.object
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      page: 1
    })

    this.props.historyStore.get(this.page, true)
  }

  changePage = action(page => {
    this.page = page
    this.props.historyStore.get(this.page)
  })

  render () {
    const { historyStore } = this.props

    if (historyStore.loading) return <Spinner />

    return <ExpertHistory changePage={this.changePage} page={this.page} />
  }
}

export default inject('historyStore')(observer(ExpertHistoryPage))
